// This is generated.  Alter it in blockGroups/searchElements/types/NestedDetail.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { propertyName } = hNode;
    //first let's look at nested search elements:
    //Each child returns TypeBox schemas in their partialTypeDefinition
    let [childDefinedSubDataDictionary, childDefinedPartialTypeDefinition] =
      hNode.children.reduce(
        (soFar, child) => {
          const [childSubDD = {}, childPartial = {}] =
            moduleRegistration
              .getHNodeType(child.hNodeTypeGroup, child.hNodeType)
              ?.asDataDictionary?.(child, context) || [];
          return [
            merge(soFar[0], childSubDD),
            Object.assign(soFar[1], childPartial),
          ];
        },
        [{}, {}],
      );

    //now let's also look at filters if they exist:
    if (hNode.filters?.length) {
      [childDefinedSubDataDictionary, childDefinedPartialTypeDefinition] =
        hNode.filters?.reduce(
          (soFar, child) => {
            const [childSubDD = {}, childPartial = {}] =
              moduleRegistration
                .getHNodeType('filters', child.hNodeType)
                ?.asDataDictionary?.(child, context) || [];
            return [
              merge(soFar[0], childSubDD),
              Object.assign(soFar[1], childPartial),
            ];
          },
          [childDefinedSubDataDictionary, childDefinedPartialTypeDefinition],
        );
    }

    const isArray = Array.isArray(hNode.filters) && hNode.filters.length > 0;
    const childObjectSchema = Type.Object(childDefinedPartialTypeDefinition, {
      title: 'Item',
      'x-dataType': 'object',
      additionalProperties: true,
    });
    const propertySchema = isArray
      ? Type.Array(childObjectSchema, {
          'x-dataType': 'array',
          'x-propertyName': propertyName,
        })
      : Type.Object(childDefinedPartialTypeDefinition, {
          'x-dataType': 'object',
          'x-propertyName': propertyName,
          additionalProperties: true,
        });

    const partialTypeDefinition = {
      [propertyName]: propertySchema,
    };

    //And the given foreignKey exists on the parent object.
    return [childDefinedSubDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'searchElements',
  'NestedDetail',
  module.exports,
);
